// French [fr]
import dayjs from 'dayjs'
import frLocale from 'dayjs/locale/fr'

const locale = {
    ...frLocale,
    formats: {
        LT: 'HH[h]mm',
        LTS: 'HH[h]mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH[h]mm',
        LLLL: 'dddd D MMMM YYYY [à] HH[h]mm'
    },
}

dayjs.locale(locale, null, true)
